import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
export default class Swipers extends React.Component {
  autoplay = { delay: 1700, waitForTransition: false };
  navigation = {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  };
  constructor(props) {
    super(props);
  }
  titleTem = (item) => {
    if (item.name) {
      return (
        <span>
          <span class="ztitle">{item.name}</span>
          <br />
          <div class="ftitle">{item.price.title}</div>
          <br />
          <span class="tj">{item.price.num1}</span>
          <span class="yj">{item.price.num2}</span>
        </span>
      );
    } else {
      return null;
    }
  };
  render() {
    return (
      <div
        style={{
          position: "relative",
          height: this.props.slidesPerView ? "215px" : "aoto",
        }}
      >
        <Swiper
          className={this.props.className || "slides_container"}
          speed={1000}
          slidesPerView={this.props.slidesPerView || 1}
          centeredSlides={this.props.centeredSlides}
          centeredSlidesBounds={this.props.centeredSlidesBounds}
          loop={true}
          autoplay={{
            ...this.autoplay,
            delay: (this.props.swiperMes && this.props.swiperMes.delay) || 1700,
          }}
          navigation={this.navigation}
          pagination={{
            clickable: true,
          }}
        >
          {this.props.slideList.map((v, index) => (
            <SwiperSlide key={index}>
              <img alt="1" src={v.src}></img>
              {this.titleTem(v)}
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </div>
    );
  }
}
